import {
    GET_EldAllSub,
    ADD_EldAllSub,
    TOGGLE_EldAllSub,
    RESET_EldAllSub,
    UPDATE_EldAllSub
  } from "../actionTypes";

const elderSubReducer = (state = {}, action) => {
  switch (action.type) {

    case GET_EldAllSub:
      return action.payload;

    case ADD_EldAllSub:
      return action.payload;

    case UPDATE_EldAllSub:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_EldAllSub:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_EldAllSub:
      return null;

    default:
      return state;
  }
};

export default elderSubReducer;
